import { getAxiosClient } from './index';
import { TrackRequest } from 'app/slice/trackerSlice';
import { uniq } from 'lodash';

export const trackClick = (trackRequest: TrackRequest) => {
    const { type, uuid, funds } = trackRequest;
    const restClient = getAxiosClient();
    return restClient.post(`/track/${type}/${uuid || 0}`, { funds: uniq(funds) });
};
